import {iframeResizer} from 'iframe-resizer';
import React from 'react';
import urlJoin from 'url-join';

import {SalesDemo} from '../../logic/api/frontendService/entities';
import EnvironmentService from '../../logic/environmentService';

const iframeResizerConfig = {};

interface Props {
  key: string;
  baseUrl: string;
  salesDemo: SalesDemo;
}

/**
 * Uncontrolled component with key, to prevent browser to add Iframe SalesDemo Url to "back-list".
 * Back button will not go back "in iframe" but in WrapperApp (router)
 * @see https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-controlled-component
 */
class IframeWrapper extends React.Component<Props> {
  private iframeRef = React.createRef<HTMLIFrameElement>();

  public componentDidMount(): void {
    const iframe = this.getCurrentIframe();
    if (iframe != undefined) {
      iframeResizer(iframeResizerConfig, iframe);

      iframe.onload = () => {
        if (EnvironmentService.isNodeEnvProd()) {
          iframe.contentWindow.scrollTo(0, 0);
        }
      };
    }
  }

  private getCurrentIframe = (): HTMLIFrameElement => {
    return this.iframeRef != undefined && this.iframeRef.current != undefined ? this.iframeRef.current : undefined;
  };

  public render() {
    const {baseUrl, salesDemo} = this.props;
    let demoUrl = urlJoin(baseUrl, salesDemo.path, '?frameless');
    // url-join removes trailing slash while our demos must contain it (they are index.html files with relative links)
    if (salesDemo.path.endsWith('/') || salesDemo.path.indexOf('/?') !== -1) {
      demoUrl = demoUrl.replace('?', '/?');
    }

    return (
      <iframe
        style={{width: '100%', border: 'none'}}
        ref={this.iframeRef}
        scrolling="no"
        allow="fullscreen"
        src={demoUrl}
      />
    );
  }
}

export default IframeWrapper;
